
import "/app/src/components/PageSection/index.module.less?modules";
export default {"section": `section-LRSmFIv9`,"header": `header-NR7AzK9k`,"title": `title-W58RwEgk`,"content": `content-NWvqdtYW`}
